<div class="insight-box">
  <div class="insight-heading">
    <div class="icon-wrap">
      <rt-icon [name]="iconName()" />
    </div>
    @if (tooltip()) {
      <div rtTooltip [rtTooltipMaxWidth]="850" [rtTooltipTemplate]="tooltipTpl">
        <rt-icon name="help-outline" />
      </div>
    }
  </div>
  <div class="insights">
    <div class="core">
      <span class="value">{{ value() }}</span>
      <span class="title">{{ title() }}</span>
    </div>
    <span class="label"> {{ label() }} </span>
  </div>
</div>

<ng-template #tooltipTpl>
  <div [innerHTML]="tooltip()"></div>
</ng-template>
